export const musicData = [
  {
    id: "mariachiCardenal",
    group: "Mariachi Cardenal de Stanford",
    location: "Stanford, CA",
    role: "Trumpet Player & Section Leader",
    timeline: "September 2021 – June 2025",
    highlights: [
      "Led trumpet section and coordinated rehearsals for performances on campus and across the Bay Area",
      "Performed traditional mariachi repertoire including sones, rancheras, and huapangos",
      "Collaborated with vocalists and rhythm section to shape ensemble sound",
    ],
    images: ["/music/mariachi_1.jpg", "/music/mariachi_2.jpg"],
    buttons: [
      {
        label: "Article",
        link: "https://drive.google.com/file/d/1ZODz2OI5Rj062FakYQVAgmRchiBbyFAp/view?usp=drive_link",
      },
    ],
  },
];
